<template>
  <div class="animated fadeIn">
    <b-card-body class="m-0 pt-0" id="areaImprimir">
      <div class="text-center">
        <b-spinner v-if="!process" label="Spinning"></b-spinner>
      </div>
      <!--        <b-row >-->
      <!--          <b-col sm="8">-->
      <!--            <h2 class="mb-3">Proceso #{{process.number}}</h2>-->
      <!--          </b-col>-->
      <!--          <b-col sm="4">-->
      <!--            &lt;!&ndash; <a href="#" class="btn btn-sm btn-success float-right ml-1"><i class="fa fa-send"></i> Enviar</a> &ndash;&gt;-->
      <!--            <a href="#" class="btn btn-sm btn-outline-danger float-right" @click="descargarPDF"><i class="fa fa-file-pdf-o"></i> Descargar </a>-->
      <!--              <a href="#" class="btn btn-sm btn-outline-danger float-right" @click="printDiv"><i class="fa fa-file-pdf-o"></i> Imprimir </a>-->
      <!--          </b-col>-->
      <!--        </b-row>-->
      <b-row class="border-bottom mb-2">
        <b-col>
          <b-img :src="img" left fluid style="max-height: 100px" alt="Responsive image" class="rounded pb-0"></b-img>
          <h1 class="text-right">INFORME DE PROCESO #{{ process.number }}</h1>
          <p class="text-right">{{ process.process_date | moment }}</p>
          <a href="#" class="float-right text-black-50" @click="descargarPDF"><i class="fa fa-download"></i></a>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col sm="3">
          <h6 class="mb-3">Procesado en:</h6>
          <div>
            <strong>{{ process.plant.name }}</strong>
          </div>
          <div>CSP: {{ process.plant.plant_code }}</div>
          <div>{{ process.plant.company.address1 }}</div>
          <div>Email: {{ process.plant.company.email }}</div>
          <div>Telefono: {{ process.plant.company.phone }}</div>
        </b-col>
        <b-col sm="3">
          <h6 class="mb-3">Solicitud:</h6>
          <div>
            <strong>{{ process.client_customer.company_name }}</strong>
          </div>
          <div>Huerto: {{ process.contents_in[0].origin_name }} ({{ process.contents_in[0].origin_code }})</div>
          <div>Producto: {{ process.contents_in[0].product_name }}</div>
          <div>Variedad: {{ process.contents_in[0].variety_name }}</div>
          <div>Condicion: {{ process.contents_in[0].condition }}</div>
        </b-col>
        <b-col sm="3">
          <h6 class="mb-3">Detalles:</h6>
          <div>Tipo de proceso: {{ process.process_type.name }}</div>
          <div>Línea de proceso: {{ process.process_room.name }}</div>
          <div>Jefe de proceso: {{ process.shift_supervisor.first_name }} {{ process.shift_supervisor.last_name }}</div>
          <div>Fecha de proceso: {{ process.process_date | moment }}</div>
          <div>Turno: {{ process.shift.name }}</div>
        </b-col>
        <b-col sm="3">
          <h6 class="mb-3">Porcentajes:</h6>
          <div v-for="process_type in groupedData">
            <div class="font-weight-bold">{{ process_type.producto }}: {{ process_type.porcentaje }}</div>
          </div>
        </b-col>
      </b-row>
      <h5 class="mb-2 font-weight-bold">Entrada a Proceso:</h5>
      <div class="table-responsive-sm">
        <table class="table table-sm">
          <thead>
            <tr class="font-weight-bold text-uppercase">
              <th class="text-center">#</th>
              <th>Pallet</th>
              <th>Guía - Lote</th>
              <th>Producto - Tipo</th>
              <th>Variedad - Condición</th>
              <th>Env./Emb.</th>
              <th>Spec</th>
              <th class="text-center">Cantidad</th>
              <th class="text-right">Kg Netos</th>
              <!--                <th class="text-right">%</th>-->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(content, index) in process.contents_in">
              <td class="text-center align-middle">{{ index + 1 }}</td>
              <td class="left align-middle">{{ content.pallet_number }}</td>
              <td class="left align-middle">{{ content.waybill_number }} - {{ content.lot_number }}</td>
              <td class="align-middle left">{{ content.product_name }} - {{ content.product_type_name }}</td>
              <td class="align-middle left">{{ content.variety_name }} - {{ content.condition }}</td>
              <td class="align-middle left">{{ content.container.name }}</td>
              <td class="align-middle left">{{ content.string_specs }}</td>
              <td class="align-middle text-center">{{ content.quantity }}</td>
              <td class="align-middle text-right">{{ content.net_kilograms }} Kg</td>
              <!--                <td class="align-middle text-right">{{dhPercentage(content.net_kilograms) }} %</td>-->
            </tr>
          </tbody>
          <tfoot>
            <tr class="font-weight-bold">
              <td class="text-center"></td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="text-right">TOTALES</td>
              <td class="text-center">{{ totalQuantityIn }}</td>
              <td class="text-right">{{ totalNetKilogramsIn }} Kg</td>
              <!--                <td class="text-right">100.00 %</td>-->
            </tr>
          </tfoot>
        </table>
      </div>

      <h5 class="mb-2 font-weight-bold">Salida de Proceso:</h5>

      <div v-for="groupedType in Object.keys(groupedItemsOut)" :key="groupedType">
        <h6 class="mb-2 font-weight-bold">{{ groupedType }}:</h6>

        <b-table
          small
          foot-clone
          :fields="
            getTypeFromName(groupedType) === 'pt' ? ptFields : getTypeFromName(groupedType) === 'w' ? wFields : mpFields
          "
          :items="groupedItemsOut[groupedType]"
        >
          <template #cell(custom_fields)="row">
            <div v-for="(field, index) in row.item.custom_fields" :key="index">
              <span v-if="field != null && field != false"
                ><strong>{{ index | labelize }}</strong> : {{ field }}
              </span>
            </div>
          </template>
          <template #cell(overweight)="row">
            <span>{{ dh(row.item.exportable_kilograms, row.item.net_kilograms) }}</span>
          </template>
          <template #foot()>
            <span></span>
          </template>
          <template #foot(net_kilograms)>
            <span>{{ sumByKey(groupedItemsOut[groupedType], "net_kilograms") }}</span>
          </template>
          <template #foot(exportable_kilograms)>
            <span>{{ sumByKey(groupedItemsOut[groupedType], "exportable_kilograms") }}</span>
          </template>
          <template #foot(overweight)>
            <span>{{
              dh(
                sumByKey(groupedItemsOut[groupedType], "exportable_kilograms"),
                sumByKey(groupedItemsOut[groupedType], "net_kilograms")
              )
            }}</span>
          </template>
          <template #foot(quantity)>
            <span>{{ sumByKey(groupedItemsOut[groupedType], "quantity") }}</span>
          </template>
        </b-table>
      </div>

      <b-row>
        <b-col lg="6">
          <b-card border-variant="white">
            <p class="font-weight-bold">Notas:</p>
            <p class="pre-formatted">{{ process.note }}</p>
          </b-card>
        </b-col>
      </b-row>
      <hr />
      <p class="small text-center">
        El Porcentaje de embalaje corresponde a la suma de los kilos netos de exportación, más los kilos netos de
        deshidratación, y se considera como el rendimiento efectivo de la fruta.
      </p>
    </b-card-body>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";
import _ from "lodash";
import labelize from "@/assets/js/utils";

export default {
  name: "Report",
  props: ["process"],
  data() {
    return {
      img: "",
      client: null,
      ptFields: [
        {
          key: "pallet_number",
          label: "Pallet"
        },
        {
          key: "product_name",
          label: "Especie"
        },
        {
          key: "variety_name",
          label: "Variedad"
        },
        {
          key: "condition",
          label: "Condición"
        },
        {
          key: "container.sku",
          label: "Código"
        },
        {
          key: "container.name",
          label: "Formato"
        },
        {
          key: "custom_fields",
          label: "Spec"
        },
        {
          key: "quantity",
          label: "Cantidad"
        },
        {
          key: "exportable_kilograms",
          label: "KExp"
        },
        {
          key: "overweight",
          label: "DH"
        },
        {
          key: "net_kilograms",
          label: "KN"
        }
      ],
      wFields: [
        {
          key: "product_name",
          label: "Especie"
        },
        {
          key: "variety_name",
          label: "Variedad"
        },
        {
          key: "condition",
          label: "Condición"
        },
        {
          key: "net_kilograms",
          label: "KN"
        }
      ],
      mpFields: [
        {
          key: "pallet_number",
          label: "Pallet"
        },
        {
          key: "product_name",
          label: "Especie"
        },
        {
          key: "variety_name",
          label: "Variedad"
        },
        {
          key: "condition",
          label: "Condición"
        },
        {
          key: "container.name",
          label: "Recipiente"
        },
        {
          key: "quantity",
          label: "Cantidad"
        },
        {
          key: "net_kilograms",
          label: "KN"
        }
      ]
    };
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    },
    labelize(value) {
      return labelize(value);
    }
  },
  computed: {
    totalNetKilogramsIn() {
      return this.process.contents_in.reduce((total, item) => total + parseFloat(item.net_kilograms), 0);
    },
    totalQuantityIn() {
      return this.process.contents_in.reduce((total, item) => total + item.quantity, 0);
    },
    totalQuantityOut() {
      return this.process.contents_out.reduce((total, item) => total + item.quantity, 0);
    },
    totalExportedKilograms() {
      var value = this.process.contents_out.reduce((acc, item) => acc + item.exportable_kilograms, 0);
      return value.toFixed(2);
    },
    totalPercentage() {
      var value = this.process.contents_out.reduce((acc, item) => acc + parseFloat(item.net_kilograms), 0);
      value = (value / this.process.total_kilograms) * 100;
      return value.toFixed(2);
    },
    totalDHKilograms() {
      const value = this.process.contents_out.reduce(
        (acc, item) => acc + parseFloat(this.dh(item.exportable_kilograms, item.net_kilograms)),
        0
      );
      return value.toFixed(2);
    },
    groupedData() {
      return _(this.process.contents_out)
        .groupBy("product_type_name")
        .map((product_type, id) => ({
          producto: id,
          tipo: product_type[0].exportable === true ? "pt" : product_type[0].waste === true ? "w" : "mp",
          kg_export: _.sumBy(product_type, "exportable_kilograms").toFixed(2),
          kg_sobrepeso: _.sumBy(product_type, (x) => parseFloat(x.net_kilograms - x.exportable_kilograms)).toFixed(2),
          bultos: _.sumBy(product_type, "quantity"),
          porcentaje:
            ((_.sumBy(product_type, (x) => parseFloat(x.net_kilograms)) / this.process.total_kilograms) * 100).toFixed(
              2
            ) + "%"
        }))
        .value();
    },
    groupedItemsOut() {
      const items = this.process.contents_out;
      const result = _(items).groupBy("product_type_name").value();
      return result;
    }
  },
  mounted() {
    this.img = localStorage.getItem("img");
    this.client = this.$store.getters.user.ID_CLIENTE;
  },
  methods: {
    sumByKey(items, key) {
      return items.reduce((acc, item) => acc + parseFloat(item[key]), 0).toFixed(2);
    },
    getTypeFromName(name) {
      return this.groupedData.find((item) => item.producto === name).tipo;
    },
    moment: function () {
      return moment();
    },
    dh(exportable_kilogram, net_kilogram) {
      const value = net_kilogram - exportable_kilogram;
      return exportable_kilogram == 0 ? 0 : parseFloat(value).toFixed(2);
    },

    printDiv() {
      const prtHtml = document.getElementById("areaImprimir").innerHTML;
      let stylesHtml = "";
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open("", "", "left=0,top=5,width=1280,height=2900,toolbar=0,scrollbars=0,status=0");
      WinPrint.document.write(`<!DOCTYPE html>
          <html>
            <head>
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    descargarPDF() {
      const element = document.getElementById("areaImprimir").innerHTML;
      const opt = {
        margin: 5,
        filename: "Informe Proceso #" + this.process.number + ".pdf",
        image: { type: "jpg", quality: 0.99 },
        html2canvas: { dpi: 192, letterRendering: true, useCORS: true },
        jsPDF: { unit: "pt", format: "letter", orientation: "landscape" }
      };
      html2pdf().from(element).set(opt).save();
    }
  }
};
</script>

<style scoped>
.table-sm th,
.table-sm td {
  padding: 0.15rem;
}
.pre-formatted {
  white-space: pre;
}
</style>
